import { JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Plus } from 'react-feather';

import React from 'react';
import usePermissionTypeSelectLogic, {
  PermissionTypeSelectComponentProps,
  CUSTOM,
} from './usePermissionTypeSelectLogic';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    iconButton: {
      padding: 0,
    },
    selectRoot: {
      '&:focus': {
        backgroundColor: theme.palette.common.white,
      },
    },
    customPermissionTypeText: {
      backgroundColor: theme.palette.common.white,
    },
    menuItem: {
      diplay: 'flex',
      justifyContent: 'space-between',
    },
    menuText: {
      width: 'auto',
      marginRight: theme.spacing(5),
    },
    add: {
      marginLeft: theme.spacing(2),
    },
  });
});

export const PermissionTypeSelectComponent = ({
  value,
  permissionTypes,
  customPermission,
  select,
  handleSelectChange,
  handleSelectAutocompleteCancel,
  handleCustomPermissionAdd,
  handleCustomPermissionChange,
  handleCustomPermissionActivate,
}: PermissionTypeSelectComponentProps) => {
  const classes = useStyles();
  return (
    <FormControl margin="none">
      <InputLabel id="permission-item-type">Permission Filter</InputLabel>
      <Select
        value={value}
        autoWidth
        open={select.isOpen}
        onOpen={select.open}
        MenuProps={{
          onClose: select.close,
        }}
        onChange={handleSelectChange}
        classes={{
          root: classes.selectRoot,
        }}
      >
        {permissionTypes.map((permissionType) => (
          <MenuItem
            key={permissionType}
            value={permissionType}
            className={classes.menuItem}
          >
            {permissionType}
          </MenuItem>
        ))}
        {customPermission.active ? (
          <MenuItem
            value={CUSTOM}
            classes={{
              root: classes.customPermissionTypeText,
            }}
            button={false}
            onKeyDown={handleSelectAutocompleteCancel}
          >
            <TextField
              type="text"
              InputProps={{
                endAdornment: (
                  <IconButton
                    aria-label={`Add custom permission`}
                    onClick={handleCustomPermissionAdd}
                    className={classes.iconButton}
                    disabled={!customPermission.current}
                  >
                    <Plus />
                  </IconButton>
                ),
              }}
              value={customPermission.current}
              onChange={handleCustomPermissionChange}
              fullWidth
              autoComplete="false"
              autoFocus
            />
          </MenuItem>
        ) : customPermission.current ? (
          <MenuItem
            value={customPermission.current}
            className={classes.menuItem}
          >
            {customPermission.current}
          </MenuItem>
        ) : (
          <MenuItem
            value={CUSTOM}
            className={classes.menuItem}
            onClick={handleCustomPermissionActivate}
          >
            New custom filter
            <Plus className={classes.add} />
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default MockHook.withHookHoc(
  PermissionTypeSelectComponent,
  usePermissionTypeSelectLogic
);
